import { useDispatch, useSelector } from "app/hooks";
import { personaliseReportActions } from "../../app/features/personaliseReport/personaliseReportSlice";

export const usePersonaliseReport = () => {
  const dispatch = useDispatch();
  const {
    firmName,
    adviserName,
    logoImage,
    welcomeNoteSelected,
    welcomeNote,
    finalNoteSelected,
    finalNote,
  } = useSelector((state) => state.personaliseReport);

  const handleFirmNameChange = (firmName: string) => {
    dispatch(personaliseReportActions.updateFirmName(firmName));
  };

  const handleAdviserNameChange = (adviserName: string) => {
    dispatch(personaliseReportActions.updateAdviserName(adviserName));
  };

  const handleLogoImageChange = (logoImage: string) => {
    if (!logoImage) {
      dispatch(personaliseReportActions.updateLogoImage(null));
      dispatch(personaliseReportActions.updateLogoScale(null));
      return;
    }
    dispatch(personaliseReportActions.updateLogoImage(logoImage));
  };

  const handleLogoScaleChange = (scale: number) => {
    dispatch(personaliseReportActions.updateLogoScale(scale));
  };

  const handleUpdateWelcomeNoteSelected = (value: boolean) => {
    dispatch(personaliseReportActions.updateWelcomeNoteSelected(value));
  };

  const handleUpdateWelcomeNote = (value: string) => {
    dispatch(personaliseReportActions.updateWelcomeNote(value));
  };

  const handleUpdateFinalNoteSelected = (value: boolean) => {
    dispatch(personaliseReportActions.updateFinalNoteSelected(value));
  };

  const handleUpdateFinalNote = (value: string) => {
    dispatch(personaliseReportActions.updateFinalNote(value));
  };

  return {
    firmName,
    handleFirmNameChange,
    adviserName,
    handleAdviserNameChange,
    logoImage,
    handleLogoImageChange,
    handleLogoScaleChange,
    welcomeNoteSelected,
    handleUpdateWelcomeNoteSelected,
    welcomeNote,
    handleUpdateWelcomeNote,
    finalNoteSelected,
    handleUpdateFinalNoteSelected,
    finalNote,
    handleUpdateFinalNote,
  };
};
